import React, { Component } from 'react'
import DashboardContainer from 'containers/DashboardContainer'
import styles from './create-time-poll.scss'
import CTPEntry from './inner-implement'

const containerId = 'create-time-poll-app-id'

class CreateTimePoll extends Component {
  render() {
    return (
      <DashboardContainer>
        <div className={styles['time-poll-container']}>
          <div id={containerId}>
            <CTPEntry />
          </div>
        </div>
      </DashboardContainer>
    )
  }
}

export default CreateTimePoll
